import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../OrganizationClassificationUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// ? LIBRARY TABLE PAGINATION FOR FOLDER WITHOUT PARENT UUID
const OrganizationClassificationTable = ({
  entities,
  totalCount,
  listLoading,
  queryParams = {},
  setQueryParams,
  openEditOrganizationClassificationPage,
  setCurrentItem,
  setOpenModal,
  allowEdit
}) => {
  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Nama",
      sort: true
    },
    {
      dataField: "dd_fund",
      text: "Dana DD",
      sort: true,
      formatter: cell => {
        const percentage = cell * 100;
        return <span>{percentage}%</span>;
      }
    },
    {
      dataField: "program_fund",
      text: "Dana Program Bersama",
      sort: true,
      formatter: cell => {
        const percentage = cell * 100;
        return <span>{percentage}%</span>;
      }
    },
    {
      dataField: "utilization_fund",
      text: "Dana Pendayagunaan",
      sort: true,
      formatter: cell => {
        const percentage = cell * 100;
        return <span>{percentage}%</span>;
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditOrganizationClassificationPage: openEditOrganizationClassificationPage,
        setCurrentItem,
        setOpenModal,
        allowEdit
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default OrganizationClassificationTable;
